import { Skeleton } from '@r/components/ui/skeleton.tsx';

export function PieChartSkeleton({ breathe = true }: { breathe?: boolean }) {
  return (
    <div className="h-[350px] w-full flex flex-col justify-center items-center space-y-9">
      <Skeleton breathe={breathe} className="w-[230px] aspect-square rounded-full" />

      <div className="items-center space-y-3 w-2/3">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-5">
            <Skeleton breathe={breathe} className="w-5 rounded-full aspect-square" />
            <Skeleton breathe={breathe} className="w-20 h-5" />
          </div>

          <div className="flex items-center space-x-5">
            <Skeleton breathe={breathe} className="w-5 rounded-full aspect-square" />
            <Skeleton breathe={breathe} className="w-20 h-5" />
          </div>

          <div className="flex items-center space-x-5">
            <Skeleton breathe={breathe} className="w-5 rounded-full aspect-square" />
            <Skeleton breathe={breathe} className="w-20 h-5" />
          </div>
        </div>
        <div className="mx-auto w-[60%] flex items-center justify-between">
          <div className="flex items-center space-x-5">
            <Skeleton breathe={breathe} className="w-5 rounded-full aspect-square" />
            <Skeleton breathe={breathe} className="w-20 h-5" />
          </div>

          <div className="flex items-center space-x-5">
            <Skeleton breathe={breathe} className="w-5 rounded-full aspect-square" />
            <Skeleton breathe={breathe} className="w-20 h-5" />
          </div>
        </div>
      </div>
    </div>
  );
}
